import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError, get, type Me } from "./api";

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await get<Me>("/api/auth/me");
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 30_000,
  });
}

export function useRefreshMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["me"] });
}

export function usePublicConfig() {
  return useQuery({
    queryKey: ["config"],
    queryFn: () => get<{ environment: string; turnstileSiteKey: string | null; signupRestricted: boolean }>("/api/config"),
    staleTime: Infinity,
  });
}
